import { API_BASE_URL, getTenantSubdomain } from "../config";

/**
 *
 * @param {string | null} startDate
 * @param {string | null} endDate
 * @returns {Promise<any>}
 */

export const fetchIncomeStApi = async (startDate = null, endDate = null) => {
  const company = getTenantSubdomain();
  let url = `${API_BASE_URL}/analytics/view_income_statement`;
  if (startDate && endDate) {
    url += `?start_date=${startDate}&end_date=${endDate}`;
  }
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "x-tenant-target": company,
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc4MjEzNDEwMSwianRpIjoiOWQwZDk2ZDQtYzAyNC00MTM0LWFhOTUtNGE1M2VjM2VkOThjIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6Im1pbGVzbGVtaSIsIm5iZiI6MTc4MjEzNDEwMSwiY3NyZiI6IjE2ZmZiMTQ3LTAxYzYtNGVjOC04Yzg4LTViMDAzNWY5N2UzMiIsImV4cCI6MTc4MjEzNzcwMX0.X-0244uc7wFYh0ZXYTwdwdLVA7Yemb_jkj0FQmUvtTQ",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch Income Statement Data.");
  }
  let data = await response.json();
  //console.log(data);
  return data;
};
